import React from 'react';
import Button from '@material-ui/core/Button';
import Snackbar from '@material-ui/core/Snackbar';
import MuiAlert from '@material-ui/lab/Alert';
import { makeStyles } from '@material-ui/core/styles';

function Alert(props) {
  return <MuiAlert elevation={6} variant="filled" {...props} />;
}

const useStyles = makeStyles((theme) => ({
  root: {
    width: '100%',
    '& > * + *': {
      marginTop: theme.spacing(2),
    },
  },
}));

export default function CustomizedSnackbars() {
  const classes = useStyles();
  const [open, setOpen] = React.useState(false);

  const handleClick = () => {
    setOpen(true);
  };

  const handleClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }

    setOpen(false);
  };

  return (
    <div className={classes.root}>
    <div>
      <Button variant="contained" onClick={handleClick}>
        Open Information snackbar
      </Button>
      <Snackbar
      anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'center',
        }}
      open={open} 
      autoHideDuration={6000} 
      onClose={handleClose}
      >
        <Alert onClose={handleClose} severity="info">
          Form successfully submitted.
        </Alert>
      </Snackbar>
</div>

    </div>




  );
}